<template>
  <div>
    <Hero title="Contact Us" :imageUrl="Image"/>
    <div class="container pb-5">
        <div class="row pt-5 pb-5 justify-content-center">
            <div class="col-12 col-md-8 fs12">
                <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSewwmbM_wocrdWLFZWE4BApeqkp3GOsnk2-rXPAO5CwcPaIOA/viewform?embedded=true" width="100%" height="1200px" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Image from '../assets/contact.jpg';
import Hero from './Hero.vue'

export default {
  name: 'app',
  components: {
    Hero
  },
  data() {
    return{
      Image
    }
  }
}


</script>
<style>
.btn-primary{
    border-radius: 0;
    background: #428193;
    width: 100%;
    padding: 1rem;
    font-size: 1.4rem;
    border: unset;
}
.btn-primary:hover{
    border: 1px solid #428193;
    background: white;
    color: #428193;
}

.freebirdFormviewerViewFooterEmbeddedBackground{
    display: none;
}
.freebirdFormviewerViewNavigationSubmitButton{
    background-color: #428193;
}
</style>


